import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

type KeyboardShortcuts = Record<string, () => void>;

export function useKeyboardShortcuts(customShortcuts?: KeyboardShortcuts) {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ignore if user is typing in an input
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        (e.target as HTMLElement).contentEditable === 'true'
      ) {
        return;
      }

      // Build shortcut key
      const parts: string[] = [];
      if (e.metaKey) parts.push('cmd');
      if (e.ctrlKey) parts.push('ctrl');
      if (e.altKey) parts.push('alt');
      if (e.shiftKey) parts.push('shift');
      parts.push(e.key.toLowerCase());
      const shortcut = parts.join('+');

      // Check custom shortcuts first
      if (customShortcuts && customShortcuts[shortcut]) {
        e.preventDefault();
        customShortcuts[shortcut]();
        return;
      }

      // Default shortcuts
      switch (shortcut) {
        case 't':
          // Go to today
          break;

        case 'alt+arrowleft':
          // Go to previous period
          break;

        case 'alt+arrowright':
          // Go to next period
          break;

        // View shortcuts
        case 'alt+1':
          navigate('/day');
          break;

        case 'alt+2':
          navigate('/week');
          break;

        case 'alt+3':
          navigate('/month');
          break;

        case 'alt+4':
          navigate('/kanban');
          break;

        case 'alt+5':
          navigate('/table');
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate, customShortcuts]);
}
